import { Box, BoxProps } from "@mantine/core"
import { CalendarAppointment } from "../../../../@client/Theasoft_ApiServer_Calendar"
import { getStripedGradientRuleFromColor } from "../../../../utils/getStripedGradientRule"

interface Props extends BoxProps {
  status: CalendarAppointment[]
  orientation?: "row" | "column"
  borderRadius?: string
}

export function AbsenceIndicator({
  status,
  orientation = "column",
  borderRadius,
  ...props
}: Props) {
  return (
    <Box
      w="10px"
      style={{
        gridRow: "span 2",
        display: "grid",
        gridAutoFlow: orientation,
        gridAutoColumns: "auto",
        gridAutoRows: "auto",
        overflow: "hidden",
        borderRadius,
        background: status.length ? "var(--mantine-color-body)" : undefined,
      }}
      bg={orientation === "column" ? undefined : "gray.4"}
      {...props}
    >
      {status?.map((status, i) => {
        const hasStartTime = Boolean(status.start)
        const hasEndTime = Boolean(status.end)
        const background = status.isLikeRequest
          ? getStripedGradientRuleFromColor(
              status?.blockColorHEX,
              `${status.backColorHEX}`
            )
          : status?.blockColorHEX

        const size = 100 - ((hasEndTime ? 25 : 0) + (hasStartTime ? 25 : 0))

        return (
          <div
            key={i}
            style={{
              background,
              position: "relative",
              top: orientation === "column" && hasStartTime ? "25%" : 0,
              left: orientation === "row" && hasStartTime ? "25%" : 0,
              height: orientation === "row" ? undefined : `${size}%`,
              width: orientation === "column" ? undefined : `${size}%`,
            }}
          />
        )
      })}
    </Box>
  )
}
